/*
 * Copyright (c) 2023. Nedaware SL
 */

import {BasicEntity, BasicProperty} from "../../basic-entity-back/annotations";
import {PropertyType} from "../../basic-entity-back/property-type/property-type";
import {Documento} from "./documento-model";
import {ExactSearchFilter} from "../../basic-entity-back/filters/search-filter";
import {NestedBehavior} from "../../basic-entity-back/property-type/nested-model-type";
import {LineaDocumento} from "./linea-documento-model";
import {PropertyMap, ReadWrite} from "../../basic-entity-back/basic-entity-interface/mapping-external";
import {LineaPedido} from "../pedidos/linea-pedido.model";


@BasicEntity({
    name: 'Factura Rectificativa',
    endpoint: 'factura_rectificativas',
    isPaginated: true,
    acceptsBulkIriSearch: true,
    paginationSizes: [20, 30, 50],
    modelNameProperty: 'lectura',
    type: 'FacturaRectificativa'
})
export class FacturaRectificativa extends Documento {
    static readonly ESTADOS_FACTURA = {
        PENDIENTE: 'Pendiente',
        FACTURADO: "Facturado",
    };

    @BasicProperty({
        name: 'Estado',
        type: PropertyType.Choice(...Object.values(FacturaRectificativa.ESTADOS_FACTURA)),
        sortable: true,
        filters: [ExactSearchFilter]
    })
    private _estado;

    @BasicProperty({
        name: 'Líneas',
        type: PropertyType.NestedModel(LineaDocumento, null, NestedBehavior.CreateOnly),
        array: true
    })
    private _lineasFacturaRectificativa: LineaDocumento[];

    @BasicProperty({
        name: 'Fecha',
        type: PropertyType.Date()
    })
    private _fecha;

    @BasicProperty({
        name: 'Número de factura',
        type: PropertyType.String()
    })
    private _numeroFactura;

    public static readonly MAP_FACTURA: PropertyMap = {
        name: 'Factura rectificada',
        type: PropertyType.FutureUri('factura.model.ts')
    }
    @BasicProperty(FacturaRectificativa.MAP_FACTURA)
    private _factura;

    get estado() {
        return this._estado;
    }

    set estado(value) {
        this._estado = value;
    }

    get lineasFacturaRectificativa(): LineaDocumento[] {
        return this._lineasFacturaRectificativa;
    }

    set lineasFacturaRectificativa(value: LineaDocumento[]) {
        this._lineasFacturaRectificativa = value;
    }

    get fecha() {
        return this._fecha;
    }

    set fecha(value) {
        this._fecha = value;
    }

    get numeroFactura() {
        return this._numeroFactura;
    }

    set numeroFactura(value) {
        this._numeroFactura = value;
    }

    get factura() {
        return this._factura;
    }

    set factura(value) {
        this._factura = value;
    }
}

// LineaDocumento.MAP_FACTURA.type = PropertyType.Uri(Factura);
